import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here

import Localization from "composer/Localization.jsx"
import LocaleViewerPage from "composer/pages/LocaleViewerPage.jsx"

import { Icon, Button, FormControl, Select, MenuItem, InputLabel, TextField, IconButton, Tooltip } from '@material-ui/core';
import {
  grey,
} from '@material-ui/core/colors'

import SchoolList from "composer/views/SchoolList.jsx"
import UserList from "composer/views/UserList.jsx"

const styles = {
  localeFilter: {
    display:'inline-block',
    verticalAlign:'middle',
    padding: '0 15px',
  },
};

class LocaleViewerBar extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      localeSort: 0,
      localeSortField: "epack.id",
      localeSortOrder: "DESC",
      filterKLA: 0,
      filterSubject: 0,
      filterSubmission: 0,
      searchText: "",
      userOption: 0,
      userList: [],
      mySchoolId: this.props.root.getMySchoolId(),
    };
    autoBind(this);

    this.getUserListBySchoolId(this.state.mySchoolId);
  }

  createLocale() {
    this.props.root.setCurrentLocale(null);
    this.props.parent.refs.createLocaleDialog.setState({open: true});
  }

  refreshLocale() {
    this.props.parent.refreshLocaleList();
  }

  filterKLAChanged(e) {
    this.setState({
      filterKLA: e.target.value
    });
    this.state.filterKLA = e.target.value;

    this.setState({ filterSubject: 0 });
    this.state.filterSubject = 0;
    this.props.parent.filterLocaleByKLA(this.state.filterKLA);
  }

  filterSubjectChanged(e) {
    this.setState({
      filterSubject: e.target.value
    });
    this.state.filterSubject = e.target.value;

    this.props.parent.filterLocaleBySubject(this.state.filterSubject);
  }

  filterSubmissionChanged(e) {
    this.setState({
      filterSubmission: e.target.value
    });
    this.state.filterSubmission = e.target.value;

    this.props.parent.filterLocaleBySubmission(this.state.filterSubmission);
  }

  searchTextChanged(e) {
    this.setState({ searchText: e.target.value });
    this.state.searchText = e.target.value;
  }

  handleSearchClicked() {
    this.props.parent.filterLocaleByKeyword(this.state.searchText);
  }

  handleSearchEnterPressed(e) {
    if (e.key === "Enter") {
      this.handleSearchClicked();
    }
  }

  showPublicOnlyChanged(e) {
    this.props.parent.setState({ showPublicOnly: e.target.value });
    this.props.parent.state.showPublicOnly = e.target.value;
    this.props.parent.changePage(0);
  }

  clearFilter() {
    this.setState({
      searchText: "",
      filterKLA: 0,
      filterSubject: 0,
      filterSubmission: 0,
    });
    this.state.searchText = "";
    this.state.filterKLA = 0;
    this.state.filterSubject = 0;
    this.state.filterSubmission = 0;

    if (this.refs.schoolList != null) {
      //this.refs.schoolList.onInputChanged(null, "", "");
    }

    if (this.props.parent.onClearFilter) {
      this.props.parent.onClearFilter();
    }
  }

  handleClearClicked() {
    this.clearFilter();

    this.refreshLocale();
  }

  localeSortChanged(e) {
    let sortField = "epack.id";
    let sortOrder = "DESC";
    switch (e.target.value) {
      case 0:
        sortField = "epack.date_created";
        sortOrder = "DESC";
        break;
      case 1:
        sortField = "epack.date_created";
        sortOrder = "ASC";
        break;
      case 2:
        sortField = "epack.date_update";
        sortOrder = "DESC";
        break;
      case 3:
        sortField = "epack.date_update";
        sortOrder = "ASC";
        break;
      case 4:
        sortField = "epack.name";
        sortOrder = "ASC";
        break;
      case 5:
        sortField = "epack.download_count";
        sortOrder = "DESC";
        break;
      case 6:
        sortField = "epack.download_count";
        sortOrder = "ASC";
        break;
      default:
        break;
    }
    this.setState({
      localeSort: e.target.value,
      localeSortField: sortField,
      localeSortOrder: sortOrder,
    })
    this.state.localeSort = e.target.value;
    this.state.localeSortField = sortField;
    this.state.localeSortOrder = sortOrder;

    this.refreshLocale();
  }

  onSchoolSelected(school) {
    this.props.parent.changePage(0, false);
    if (school != null) {
      this.props.parent.setState({ filterSchoolID: school.value });
      this.props.parent.state.filterSchoolID = school.value;
    }
    else {
      this.props.parent.setState({ filterSchoolID: null });
      this.props.parent.state.filterSchoolID = null;
    }

    this.refreshLocale();
  }

  getUserListBySchoolId(schoolId) {
    var requestObj = {school_id: schoolId};
    this.props.root.refs.API.request("get_user_data_by_school_id", requestObj, this.getUserListOK, this.getUserListFailed);
  }

  getUserListOK(res) {
    this.setState({userList: res.body['result']});
    this.setDefaultUserOption(this.props.root.getMyUserId());
  }

  getUserListFailed(err) {
    console.log("getUserListFailed");
  }

  setDefaultUserOption(userId) {
    let option = 0;

    for (var i = 0; i < this.state.userList.length; i++) {
      if (this.state.userList[i]['id'] == userId) {
        option = i;
      }
    }

    this.setState({ userOption: option });
    this.state.userOption = option;
  }

  userOptionChanged(e) {
    let index = e.target.value;
    this.setState({ userOption: index });
    this.state.userOption = index;

    this.clearFilter();

    if (index < 0) {
      this.props.parent.filterLocaleBySchoolAndUserId(this.state.mySchoolId, null);
    }
    else {
      let userId = this.state.userList[index]['id'];
      this.props.parent.filterLocaleBySchoolAndUserId(this.state.mySchoolId, userId);
    }
  }

  render() {
      return (
        <div ref="div" style={{padding:"10px 0 10px 10px", backgroundColor:grey[300]}}>

          <Button
            color="secondary"
            variant="contained"
            className="margin-sm"
            onClick={this.createLocale}
          >

            <Icon className="buttonIconLeft">add</Icon>
            {Localization.strings.NEW_LOCALE}
          </Button>


          <Button
            color="primary"
            variant="contained"
            className="margin-sm"
            onClick={this.refreshLocale}
          >
            <Icon className="buttonIconLeft">refresh</Icon>
            {Localization.strings.REFRESH}
          </Button>

          <Switch condition={this.props.parent.state.currentView}>
            <Case value={LocaleViewerPage.VIEW_LOCALE_LIST()}>
              <Button
                color="primary"
                variant="contained"
                className="margin-sm"
                onClick={()=>this.props.parent.changeView(LocaleViewerPage.VIEW_LOCALE_MAP())}
              >
                <Icon className="buttonIconLeft">map</Icon>
                {Localization.strings.SWITCH_TO_MAP}
              </Button>
            </Case>
            <Case value={LocaleViewerPage.VIEW_LOCALE_MAP()}>
              <Button
                color="primary"
                variant="contained"
                className="margin-sm"
                onClick={()=>this.props.parent.changeView(LocaleViewerPage.VIEW_LOCALE_LIST())}
              >
                <Icon className="buttonIconLeft">list</Icon>
                {Localization.strings.SWITCH_TO_LIST}
              </Button>
            </Case>
          </Switch>

          <If condition={this.props.root.isAdminUser()}>
            <Then>
              <div style={styles.localeFilter}>
                <FormControl style = {{width: 150}}>
                  <InputLabel>{Localization.strings.PUBLIC_LOCALE_ONLY}</InputLabel>
                  <Select
                    value={this.props.parent.state.showPublicOnly}
                    onChange={this.showPublicOnlyChanged}
                  >
                    <MenuItem value={1}>{Localization.strings.YES}</MenuItem>
                    <MenuItem value={0}>{Localization.strings.NO}</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div style={styles.localeFilter}>
                <FormControl style = {{width: 80}}>
                  <InputLabel style={{width: 90}}>{Localization.strings.QA_STATE}</InputLabel>
                  <Select
                    value={this.props.parent.state.qaState}
                    onChange={this.props.parent.onQAStateChanged}
                  >
                    <MenuItem value={-1}>{Localization.strings.QA_STATE_ANY}</MenuItem>
                    <MenuItem value={0}>{Localization.strings.QA_STATE_UNCHECKED}</MenuItem>
                    <MenuItem value={1}>{Localization.strings.QA_STATE_CHECKED}</MenuItem>
                    <MenuItem value={2}>{Localization.strings.QA_STATE_MINOR}</MenuItem>
                    <MenuItem value={3}>{Localization.strings.QA_STATE_MAJOR}</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </Then>
          </If>

          <div style={styles.localeFilter}>
            <FormControl>
              <InputLabel>{Localization.strings.SCHOOL}</InputLabel>
              <Select
                value={this.props.parent.state.isViewPublic? 1 : 0}
                onChange={this.props.parent.onViewAngleChanged}
              >
                <MenuItem value={0}>{Localization.strings.MY_SCHOOL}</MenuItem>
                <MenuItem value={1}>{Localization.strings.ALL_SCHOOLS}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <If condition={this.props.parent.state.isViewPublic}>
            <Then>
              <div style={styles.localeFilter}>
                <SchoolList parent={this} root={this.props.root} ref="schoolList"
                  onSchoolSelected={this.onSchoolSelected}
                />
              </div>
            </Then>
          </If>

          <If condition={!this.props.parent.state.isViewPublic}>
            <Then>
              <div style={styles.localeFilter}>
                <UserList parent={this} root={this.props.root}
                  userOption={this.state.userOption}
                  userList={this.state.userList}
                />
              </div>
            </Then>
          </If>

          <div style={styles.localeFilter}>
            <FormControl>
              <InputLabel>{Localization.strings.SORT_BY}</InputLabel>
                <Select
                  value={this.state.localeSort}
                  onChange={this.localeSortChanged}
                >
                  <MenuItem value={0}>{Localization.strings.SORT_CREATE_DATE_DESC}</MenuItem>
                  <MenuItem value={1}>{Localization.strings.SORT_CREATE_DATE_ASC}</MenuItem>
                  <MenuItem value={2}>{Localization.strings.SORT_MODIFY_DATE_DESC}</MenuItem>
                  <MenuItem value={3}>{Localization.strings.SORT_MODIFY_DATE_ASC}</MenuItem>
                  <MenuItem value={4}>{Localization.strings.SORT_NAME_ASC}</MenuItem>
                  <MenuItem value={5}>{Localization.strings.SORT_DOWNLOAD_COUNT_DESC}</MenuItem>
                  <MenuItem value={6}>{Localization.strings.SORT_DOWNLOAD_COUNT_ASC}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={styles.localeFilter}>
            <FormControl>
              <InputLabel>{Localization.strings.KLA_SHORT}</InputLabel>
              <Select
                value={this.state.filterKLA}
                onChange={this.filterKLAChanged}
              >
                {this.props.root.refs.userDataProfile.state.kla.map( (row, i) => {
                  return (
                    <MenuItem key={i} value={i}>{row[Localization.strings.getLanguage() === "en"? 'name_eng' : 'name']}</MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
          <div style={styles.localeFilter}>
            <FormControl>
              <InputLabel>{Localization.strings.SUBJECT}</InputLabel>
              <Select
                value={this.state.filterSubject}
                onChange={this.filterSubjectChanged}
              >
                <MenuItem value={0}>{Localization.strings.UNSPECIFIED_SUBJECT}</MenuItem>
                  {this.props.root.refs.userDataProfile.state.subject.map( (row, i) => {
                    if (this.state.filterKLA > 0 && parseInt(row['kla_id']) === this.state.filterKLA) {
                      return (
                        <MenuItem value={i+1}>{row[Localization.strings.getLanguage() === "en"? 'name_eng' : 'name']}</MenuItem>
                      );
                    }
                  })}
              </Select>
            </FormControl>
          </div>
          <div style={styles.localeFilter}>
            <FormControl style={{width:"160px"}}>
              <InputLabel >{Localization.strings.OWN_SUBMISSION}</InputLabel>
              <Select
                value={this.state.filterSubmission}
                onChange={this.filterSubmissionChanged}
              >
                <MenuItem value={1}>{Localization.strings.YES}</MenuItem>
                <MenuItem value={0}>{Localization.strings.NO}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={styles.localeFilter}>
            <TextField
              margin="normal"
              size="small"
              variant="outlined"
              value={this.state.searchText}
              onChange={this.searchTextChanged}
              label={Localization.strings.SEARCH}
              placeholder={Localization.strings.LOCALE_SEARCH_TEXT_PLACEHOLDER}
              InputLabelProps={{ shrink: true }}
              onKeyPress={this.handleSearchEnterPressed}
            />
          </div>
          <Tooltip title={Localization.strings.SEARCH} style={{top:"3px"}}>
            <IconButton
              onClick={this.handleSearchClicked}
            >
              <Icon>search</Icon>
            </IconButton>
          </Tooltip>
          <Tooltip title={Localization.strings.CLEAR} style={{top:"3px"}}>
            <IconButton
              onClick={this.handleClearClicked}
            >
              <Icon>clear</Icon>
            </IconButton>
          </Tooltip>
        </div>
      )
  }
}

export default LocaleViewerBar;
